import { industryConstants, alertConstants } from '../_constants'
const initialState = {
  isLoading: false,
  industryEntry: null,
  addIndustryMessage: null,
  updateIndustryMessage: null,
  count: 0,
  industryList: [],
  isGetAllError: false,
  deletedData: {},
  masterList: null,
  updateFilterMessage: '',
  isErrorOnUploadFilter: false,
  isPageLoad: true,
  currentPage: 0
}

export function industry(state = { ...initialState }, action) {

  switch (action.type) {
  case alertConstants.CLEAR:
    return {
      ...state,
      addIndustryMessage: null,
      updateIndustryMessage: null,
      deletedData: {},
      isGetAllError: false,
      industryEntry: '',
    }
  case industryConstants.ADD_REQUEST:
    return {
      ...state,
      loading: true,
      addIndustryMessage: null
    }
  case industryConstants.ADD_SUCCESS:
    return {
      ...state,
      addIndustryMessage: action.industry.message,
      isLoading: false,
    }

  case industryConstants.GETALL_SUCCESS:
    return {
      ...state,
      industryList: action.industry.data,
      count: action.industry.count,
      isLoading: false
    }
  case industryConstants.GETALL_FAILURE:
    return {
      ...state,
      error: action.error,
      industryList: [],
      isLoading: false,
      count: 0
    }
  case industryConstants.GETALL_REQUEST:
    return {
      ...state,
      error: null,
      isLoading: true,
      updateIndustryMessage: null
    }
  case industryConstants.GETBYID_SUCCESS:
    return {
      ...state,
      industryEntry: action.industry,
      isLoading: false,
      addIndustryMessage: null,
      updateIndustryMessage: null
    }
  case industryConstants.GETBYID_FAILURE:
    return {
      ...state,
      error: action.error,
      isLoading: false,
      addIndustryMessage: null,
      updateIndustryMessage: null
    }
  case industryConstants.GETBYID_REQUEST:
    return {
      ...state,
      industryEntry: action.industry,
      isLoading: true,
      addIndustryMessage: null
    }
  case industryConstants.GETALL_PAGE_REQUEST:
    return {
      ...state,
      isLoading: true,
      addIndustryMessage: null,
      isPageLoad: action.industry.search ? false : true,
      currentPage: action.industry.start
    }
  case industryConstants.GETALL_PAGE_FAILURE:
    return {
      ...state,
      error: action.error,
      isLoading: false,
      industryList: [],
      count: 0,
      isGetAllError: true,
      addIndustryMessage: null
    }
  case industryConstants.GETALL_PAGE_SUCCESS:
    return {
      ...state,
      error: action.error,
      isLoading: false,
      addIndustryMessage: null,
      industryList: action.industry.data,
      count: action.industry.count,
    }
  case industryConstants.DELETE_REQUEST:
    return {
      ...state,
      isLoading: true,
      addIndustryMessage: null
    }
  case industryConstants.DELETE_SUCCESS:
    return {
      ...state,
      isLoading: false,
      deletedData: action.response,
      addIndustryMessage: null
    }
  case industryConstants.DELETE_FAILURE:
    return {
      ...state,
      isLoading: false,
      updateIndustryMessage: null
    }
  case industryConstants.UPDATE_SUCCESS:
    return {
      ...state,
      isLoading: false,
      updateIndustryMessage: action.industry.message,
    }
  case industryConstants.UPDATE_FAILURE:
    return {
      ...state,
      isLoading: false,
      updateIndustryMessage: action.message,
    }

  case industryConstants.UPDATE_REQUEST:
    return {
      ...state,
      isLoading: true,
      updateIndustryMessage: null
    }
  case industryConstants.UPDATE_FILTER_REQUEST:
    return {
      ...state,
      isLoading: true,
      updateFilterMessage: null,
      isErrorOnUploadFilter: false
    }
  case industryConstants.UPDATE_FILTER_SUCCESS:
    return {
      ...state,
      isLoading: false,
      updateFilterMessage: action.response.message,
      isErrorOnUploadFilter: false
    }
  case industryConstants.UPDATE_FILTER_FAILURE:
    return {
      ...state,
      isLoading: false,
      updateFilterMessage: null,
      isErrorOnUploadFilter: true
    }
  default:
    return state
  }
}
